module.exports = __webpack_public_path__ + "static/splatoon-91b115794fcf127d124cba3338d956e7.png";